import * as React from 'react';
import ConfirmationModal from 'components/Common/confirmationModal';
import './deleteCycleConfirmationModal.scss';

export interface IDeleteCycleConfirmationModalProps {
    isModalOpen: () => boolean;
    closeModal: () => void;
    onDeleteCycleClick: () => void;
}

export class DeleteCycleConfirmationModal extends
    React.Component<IDeleteCycleConfirmationModalProps> {
    constructor(props: IDeleteCycleConfirmationModalProps) {
        super(props);
        this._closeDeleteCycleModal = this._closeDeleteCycleModal.bind(this);
        this._deleteCycleClick = this._deleteCycleClick.bind(this);
        this._cancelDeleteCycleModal = this._cancelDeleteCycleModal.bind(this);
    }

    render(): React.ReactNode {
        if (!this.props.isModalOpen()) {
            return null;
        }

        return (
            <ConfirmationModal
                title="Delete Cycle"
                className="nomst-delete-cycle-modal"
                message={this.renderDeleteCycleMessage()}
                onCancel={this._cancelDeleteCycleModal}
                onClose={this._closeDeleteCycleModal}
                onConfirm={this._deleteCycleClick}
            />
        );
    }

    private renderDeleteCycleMessage(): React.ReactNode {
        return (<h3 className="nomst-delete-cycle-modal__message">Are you sure you want to delete this cycle?</h3>);
    }

    private _closeDeleteCycleModal(): void {
        this.props.closeModal();
    }

    private _cancelDeleteCycleModal(): void {
        this._closeDeleteCycleModal();
    }

    private _deleteCycleClick(): void {
        this._closeDeleteCycleModal();
        this.props.onDeleteCycleClick();
    }
}

export default DeleteCycleConfirmationModal;